import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-unlock",
  templateUrl: "./med-icon-unlock.component.html",
})
export class MedIconUnlockComponent extends SvgMixinComponent {}
